<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-md-12">
            <div class="card-box">

                 <div class="form-row">
                    <div class="col-md-11">
                    </div>
                    <div class="col-md-1" v-if="items">
                        <h4 class="text-center">{{$t('str.total')}}</h4>
                        <h4 class="text-center" style="color:grey">{{items.length}}</h4>
                    </div>
                </div>
                 <form>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{$t('string.msg.expired.certifie.label.days')}}
                            </label>
                            <input v-model="data.days" type="text" class="form-control" :placeholder='$t("string.msg.expired.certifie.placeholder.days")' v-mask="['##']"/>
                        </div>
                        <div class="form-group col-md-6">
                            <label class="col-form-label">
                                {{$t('string.msg.truck.certified.label')}}
                            </label>
                            <select id="truck" v-model="data.certifie" class="form-control">
                                <option value="-1" selected>{{$t('string.msg.select.selector.item')}}</option>
                                <option :value="item" v-bind:key="item" v-for="item in certifies">{{$t(item.name)}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between bd-highlight mb-3">
                        <button @click="filter()" class="btn btn-success w-30">{{$t('string.msg.form.btn.search')}}</button>
                        <download-excel v-if="items && items.length>0"
                            class   = "btn btn-primary"
                            :fetch   = "fetchData"
                            :fields = "json_fields"
                            type    = "csv"
                            name    = "expiredCertifies.xls">
	                        Download CSV
                        </download-excel>
                    </div>
                    
                </form>
                <div class="table-responsive">
                    <table class="table table-centered table-hover mb-0" id="datatable">
                        <thead>
                            <tr>
                                <th class="border-top-0">{{$t('string.msg.company.label.name')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.main.email')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.primaryPhone')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.truck')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.plate')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.certified')}}</th>
                                <th class="border-top-0">{{$t('string.msg.company.label.date')}}</th>
                            </tr>
                        </thead>
                        <tbody v-bind:key="item._id" v-for="item in items" class="cursor-pointer">
                            <tr v-if="item && item.truckDriver">
                                <td>
                                    <span v-if="item.truckDriver.firstName"> {{toUpperCase(item.truckDriver.firstName + ' ')}} </span>
                                    <span v-if="item.truckDriver.lastName"> {{toUpperCase(item.truckDriver.lastName)}} </span>
                                </td>
                                <td>
                                    <span v-if="item.truckDriver.email">
                                        {{(item.truckDriver.email)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.truckDriver.primaryPhone">
                                        {{(item.truckDriver.primaryPhone)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.manufacturer && item.manufacturer.name">{{ toUpperCase(item.manufacturer.name) + ' - '}}</span>
                                    <span v-if="item.manufacturer && item.manufacturer.name">{{item.model && item.model.name ? toUpperCase(item.model.name) + ' - ' : '' + ' - '}}</span>
                                    <span v-if="item.manufacturer && item.manufacturer.name">{{item.year}}</span>
                                </td>
                                <td>
                                    <span v-if="item.plate">
                                        {{ toUpperCase(item.plate)}}
                                    </span>
                                </td>
                                <td>
                                    <span v-if="item.certifies && item.certifies.length > 0"> 
                                         <span  v-bind:key="itemCertifie._id" v-for="itemCertifie in item.certifies"> 
                                            <span v-if="itemCertifie && itemCertifie.certified">
                                                <label>{{ toUpperCase(itemCertifie.certified.name)}}</label> 
                                            </span><br/>
                                         </span>
                                    </span>
                                </td>
                                 <td>
                                       <span v-if="item.certifies && item.certifies.length > 0"> 
                                         <span  v-bind:key="itemCertifie._id" v-for="itemCertifie in item.certifies"> 
                                            <span v-if="itemCertifie && itemCertifie.certified">
                                                 <span v-if="itemCertifie.expiredDate && (new Date(itemCertifie.expiredDate)) < (new Date())">
                                                    <label style="color:red">{{ new Date(itemCertifie.expiredDate).toLocaleDateString()}}</label> 
                                                </span>
                                                  <span v-else-if="!itemCertifie.expiredDate">
                                                    <label>{{$t('str.msg.no.date.expired.certified')}}</label> 
                                                </span>
                                                <span v-else>
                                                    <label style="color:green">{{ new Date(itemCertifie.expiredDate).toLocaleDateString()}}</label> 
                                                </span>
                                            </span><br/>
                                         </span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Controller from './CrtExpiredCertifie';
import JsonExcel from 'vue-json-excel'
import Vue from 'vue'
Vue.component('downloadExcel', JsonExcel)
export default {
  name: 'ExpiredCertifie',
  props: ["valuekey"],
  watch:{
    'valuekey'(){}
  },
  components: {
  },
  data() {
      return {
        errors: [],
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        certifies:null,
        items: [],
        data:{
            days:null,
            certifie:null,
        },
        json_fields: {
            'Nome': 'truckDriver.firstName',
            'Sobrenome': 'truckDriver.lastName',
            'Telefone': 'truckDriver.primaryPhone',
            'Email': 'truckDriver.email',
            'Veiculo': 'manufacturer.name',
            'Placa': 'plate',
            'CPF': 'truckDriver.customerUser.document',
            'RG': 'truckDriver.customerUser.rg',
            'CNH': 'truckDriver.customerUser.cnh',
            
        },
        json_data: [
            {
                truckDriver:{
                    firstName: null,   
                    lastName: null,        
                    primaryPhone: null,
                    email: null,
                    customerUser:{
                        document: null,
                        cnh: null,
                        rg: null,
                    }
                },
                manufacturer:{
                    name: null
                },
                plate: null,
            }
        ],
        json_meta: [
            [
                {
                    'key': 'charset',
                    'value': 'utf-8'
                }
            ]
        ],
      }
  },
  methods: Controller.methods,
  created() {
      Controller.init(this);
    
  },
  mounted(){

  }
}
</script>